import { RootState } from "@dashboard/config/redux/store";

export const deliveryHistorySelector = (state: RootState) =>
  state.delivery.history;
export const deliveryCalculationSelector = (state: RootState) =>
  state.delivery.calculation;
export const deliverySelectedProviderSelector = (state: RootState) =>
  state.delivery.selectedProvider;
export const deliveryProvidersSelector = (state: RootState) =>
  state.delivery.providers;
export const deliveryProvidersLoadingSelector = (state: RootState) =>
  state.delivery.providersLoading;
export const deliveryCurrentDetailSelector = (state: RootState) =>
  state.delivery.currentDetail;
export const deliveryConfigDataSelector = (state: RootState) =>
  state.delivery.deliveryConfigData;
